<template>
  <div v-show="menuVisible">
    <div :ref="domRef" class="drop-table-menu">
      <div class="drop-table-menu-header">选择要展示的表头项</div>
      <div class="drop-table-menu-check-wrap">
        <ElCheckbox
          v-model="checkAll"
          :style="{
            display: 'block',
            margin: '0',
            padding: '5px',
            whiteSpace: 'nowrap',
          }"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        >
          全选
        </ElCheckbox>
        <ElCheckboxGroup
          v-model="compoundData.checkedHeaders"
          @change="handleCheckedHeadersChange"
        >
          <ElCheckbox
            v-for="header in headers"
            :key="header.prop"
            :label="header.prop"
            :style="{
              display: 'block',
              margin: '0',
              padding: '5px',
            }"
          >
            <div>{{ header.label }}</div>
          </ElCheckbox>
        </ElCheckboxGroup>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { UnwrapNestedRefs } from "vue";
import { ElCheckbox, ElCheckboxGroup } from "element-plus";
import { defineComponent, reactive, ref, nextTick, computed } from "vue";
import type { Ref, ComputedRef } from "vue";
import $ from "jquery";
import type { DataTableColumnType, DataTableType, HeaderMenuCompoundDataType } from "./types";

export default defineComponent({
  components: {
    ElCheckbox,
    ElCheckboxGroup,
  },
  props: {
    getTableObj: {
      // 返回table实例
      type: Function,
      default: (obj: DataTableType | null) => {
        obj;
      },
    },
  },
  setup(props) {
    let refMenuWrap: HTMLElement | any;
    const domRef = (el: HTMLElement | any): void => {
      refMenuWrap = el;
    };

    const menuVisible: Ref<boolean> = ref(false);
    const checkAll: Ref<boolean> = ref(false);
    const isIndeterminate: Ref<boolean> = ref(true);

    let compoundData: UnwrapNestedRefs<HeaderMenuCompoundDataType> = reactive({
      checkedHeaders: [],
      loading: false,
      headers: [],
    });

    let headers: ComputedRef<Array<DataTableColumnType>> = computed(() => {
      const tableObj: DataTableType = props.getTableObj();
      let res: Array<DataTableColumnType> = [];
      if (tableObj as DataTableType) {
        res = flatHeaders(tableObj.tableHeader);
      }
      return res;
    });

    /**
     * 扁平化表头数据
     * @param  {Array} tableHeader 表头配置或者子级配置
     */
    function flatHeaders(
      tableHeader: Array<DataTableColumnType>
    ): Array<DataTableColumnType> {
      let res: Array<DataTableColumnType> = [];
      tableHeader &&
        tableHeader.map((item: DataTableColumnType) => {
          res.push(item);
          if (item.children) {
            res = res.concat(
              flatHeaders(item.children as Array<DataTableColumnType>)
            );
          }
        });
      return res;
    }
    /**
     * 设置选中的表头
     */
    function setCheckedHeaders(): Array<string> {
      const tableObj: DataTableType = props.getTableObj();
      let resArr: Array<string> = [];
      if (tableObj) {
        resArr = tableObj.compoundData.showHeadersState;
      }
      return resArr;
    }
    /**
     * 右键点击
     *  @param  {Event} MouseEvent 右键事件
     */

    function rightClick(mouseEvent: MouseEvent): void {
      compoundData.checkedHeaders = setCheckedHeaders();

      handleCheckedHeadersChange(compoundData.checkedHeaders);
      // 鼠标右击触发事件
      menuVisible.value = false;
      menuVisible.value = true;
      const menu = refMenuWrap;
      document.addEventListener("click", hidenMenu);
      menu.style.display = "block";
      menu.style.left = mouseEvent.pageX - 0 + "px";
      menu.style.top = mouseEvent.pageY - 0 + "px";
    }
    /**
     * 点击事件隐藏
     *  @param  {Event} e 点击事件
     */
    function hidenMenu(e: MouseEvent): void {
      if (
        e.target != null &&
        !$(e.target).parents().filter(refMenuWrap).length
      ) {
        menuVisible.value = false;
        document.removeEventListener("click", hidenMenu);
      }
    }
    /**
     * 当触发全选表头
     *  @param  {Object} val 点击事件
     */
    function handleCheckAllChange(val: string): void {
      compoundData.checkedHeaders = val ? headers.value.map((o) => o.prop) : [];
      isIndeterminate.value = false;
      handleCheckedHeadersChange(compoundData.checkedHeaders);
    }
    /**
     * 切换展示设置回table上的值
     *  @param  {Array} value 设置表头的值
     */
    function handleCheckedHeadersChange(value: Array<string>): void {
      const tableObj: DataTableType = props.getTableObj();
      tableObj.compoundData.showHeadersState = value;

      const checkedCount = value.length;
      checkAll.value = checkedCount === headers.value.length;
      isIndeterminate.value =
        checkedCount > 0 && checkedCount < headers.value.length;

      nextTick(() => {
        if (tableObj.refs.elTableRef && tableObj.refs.elTableRef.doLayout) {
          tableObj.refs.elTableRef.doLayout();
        }
      });
    }
    return {
      menuVisible,
      checkAll,
      isIndeterminate,
      compoundData,
      headers,
      domRef,
      handleCheckAllChange,
      handleCheckedHeadersChange,
      rightClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.drop-table-menu {
  padding: 0;
  position: fixed;
  border: 1px solid #eee;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  margin: 0;
  z-index: 120;
  &-header {
    padding: 7px 10px;
    border-bottom: 1px solid #eee;
  }
  &-check-wrap {
    padding: 10px;
    max-height: 250px;
    overflow: auto;
  }
  &-list {
    font-size: 14px;
    padding: 0;
    margin: 0;
    list-style: none;

    &-item:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
    &-item {
      font-size: 15px;
      list-style: none;
      padding: 5px 10px;
      margin: 0;
    }
  }
}
</style>
